<template>
  <div class="wrap-lg">
    <div class="boxs-top clearfix">
      <div class="top-title"><span>资源中心</span></div>
      <div class="top-more">
        <my-link :href="toMore">
          查看更多
          <i class="el-icon-arrow-right"></i>
        </my-link>
      </div>
      <div class="switch-resource">
        <div :class="(currIndex === 1)? 'active-btn' : ''" @click="switchTab(1)">标准库</div>
        <div :class="(currIndex === 2)? 'active-btn' : ''" @click="switchTab(2)">配方库</div>
        <div :class="(currIndex === 3)? 'active-btn' : ''" @click="switchTab(3)">法规库</div>
      </div>
    </div>
    <div class="top-divider"></div>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card shadow="hover">
          <ul v-if="currIndex === 1">
            <li v-for="item in standards" :key="item.id">
              <i class="hot-fire" v-if="item.isHot === '1'"/>
              <my-link :style="item.isHot === '1'?'margin-left:5px;':'margin-left:24px;'" :href="'/standard/detail?sid='+item.id+'&viewType='+item.viewType+'&tableType=web_test_standard'" :right="{tableType:'web_test_standard',rowId:item.id,viewType:item.viewType}" :title="item.description">
                <span v-if="item.code">【{{item.code}}】</span>
                <span>{{item.title}}</span>
                <el-tag v-if="item.typeCode" size="mini" type="success" style="margin-left: 8px;">{{commonUtils.getDictName('standard_type',item.typeCode)}}</el-tag>
                <el-tag v-if="item.categoryCode" size="mini" type="primary" style="margin-left: 8px;">{{commonUtils.getDictName('inspection_type',item.categoryCode)}}</el-tag>
                <resource-price :values="item"></resource-price>
                <el-divider direction="vertical"></el-divider>
                <span v-if="item.description" style="color: #CCCCCC">{{item.description}}</span>
              </my-link>
            </li>
          </ul>
          <ul v-if="currIndex === 2">
            <li v-for="item in formulas" :key="item.id">
              <i class="hot-fire" v-if="item.isHot === '1'"/>
              <my-link :style="item.isHot === '1'?'margin-left:5px;':'margin-left:24px;'" :href="'/formula/detail?sid='+item.id+'&viewType='+item.viewType+'&tableType=web_formulat'" :right="{tableType:'web_formulat',rowId:item.id,viewType:item.viewType}" :title="item.description">
                <span v-if="item.productCode">【{{item.productCode}}】</span>
                <span>{{item.title}}</span>
                <el-tag v-if="item.categoryCode" size="mini" type="primary" style="margin-left: 8px;">{{commonUtils.getDictName('product_formula_type',item.categoryCode)}}</el-tag>
                <resource-price :values="item"></resource-price>
                <span v-if="item.description" style="color: #CCCCCC"><el-divider direction="vertical"></el-divider>{{item.description}}</span>
              </my-link>
            </li>
          </ul>
          <ul v-if="currIndex === 3">
            <li v-for="item in laws" :key="item.id">
              <i class="hot-fire" v-if="item.isHot === '1'"/>
              <my-link :style="item.isHot === '1'?'margin-left:5px;':'margin-left:24px;'" :href="'/laws/detail?sid='+item.id+'&viewType='+item.viewType+'&tableType=web_laws'" :right="{tableType:'web_laws',rowId:item.id,viewType:item.viewType}" :title="item.description">
                <span v-if="item.code">【{{item.code}}】</span>
                <span>{{item.title}}</span>
                <el-tag v-if="item.categoryCode" size="mini" type="primary" style="margin-left: 8px;">{{commonUtils.getDictName('law_type',item.categoryCode)}}</el-tag>
                <resource-price :values="item"></resource-price>
                <span v-if="item.description" style="color: #CCCCCC"><el-divider direction="vertical"></el-divider>{{item.description}}</span>
              </my-link>
            </li>
          </ul>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getFirst as lawList } from '@/api/resource/law'
import { getFirst as standardList } from '@/api/resource/standard'
import { getFirst as formulaList } from '@/api/resource/formula'
export default {
  name: 'resource',
  data () {
    return {
      laws: [],
      standards: [],
      formulas: [],
      toMore: 'standard',
      loading: false,
      currIndex: 1
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData: function () {
      this.getLawList() // 通知公告
      this.getStandardList() // 行业公告
      this.getFormulaList()
    // 初始化数据
    },
    getLawList () {
      lawList().then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.laws = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getStandardList () {
      standardList().then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.standards = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getFormulaList () {
      formulaList().then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.formulas = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    switchTab (index) {
      this.currIndex = index
      if (index === 1) {
        this.toMore = 'standard'
      } else if (index === 2) {
        this.toMore = 'formula'
      } else if (index === 3) {
        this.toMore = 'laws'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ul{
    margin: 0;
    padding: 0;
    height: 300px;
    li{
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      text-align: left;
      margin: 0 10px;
      line-height: 38px;
      list-style: none;
      text-overflow :ellipsis;
      white-space :nowrap;
      overflow : hidden;
      .hot-fire{
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 24px;
        background-image: url("../../assets/img/icon/hot_fire.png");
        background-repeat: no-repeat;
        background-size: 100%;
      }
      a{
        color: #303133;
        text-decoration: none;
        &:hover {
          font-weight: bold;
        }
      }
    }
  }
  .resource-more{
    cursor: pointer;
    float: right;
    text-align: center;
    line-height: 32px;
    width: 100px;
    height: 32px;
    background: #EFEFEF;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    a{
      text-decoration: none;
      &:hover {
        font-weight: bold;
      }
    }
  }
</style>
